import Icon, { IconName } from '@features/ui-atoms/components/Icon';
import Tooltip from '@features/ui-atoms/components/Tooltip';
import { styled } from '@mui/joy';
import { useTranslation } from 'next-i18next';

export const DebrisBadge = () => {
  const { t } = useTranslation('common');

  return (
    <BadgeContainer data-testid="debris-badge">
      <Tooltip title={t('sst.debris.tooltip')}>
        <BadgeIcon>
          <Icon name={IconName.debris} size={18} />
        </BadgeIcon>
      </Tooltip>
    </BadgeContainer>
  );
};

const BadgeContainer = styled('div')(({ theme: { palette } }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  backgroundColor: palette.grey1,
  borderRadius: '20px',
  padding: '4px 6px',
  height: '20px',
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: '16px',
}));

const BadgeIcon = styled('div')(({ theme: { palette } }) => ({
  color: palette.grey5,
  display: 'flex',
  alignItems: 'center',
}));
